import { useAlertsStore } from "@/stores/alerts";
import dayjs from "dayjs";

export function complexSearch(needle: string, hayStack: string) {
  // Handle null, undefined, or non-string values
  if (!hayStack || typeof hayStack !== 'string') {
    return false;
  }
  
  const userData = hayStack.toLowerCase();
  const search = needle.toLowerCase().trim().split(",").filter(Boolean);
  return search.length
    ? search.some((filter) =>
        filter.trim()
          ? filter
              .trim()
              .split(" ")
              .every((word) => userData.includes(word))
          : false
      )
    : true;
}

export default function downloadFile(
  file: any,
  filename: string,
  type: "text/csv" | "application/pdf"
) {
  const link = document.createElement("a");
  document.body.appendChild(link);
  const blob = new Blob([file], { type });
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  link.click();
  link.remove();
}

export function isDateString(str: string) {
  return dayjs(str).isValid() || !!str.match(/^[0-2][0-9]:[0-5][0-9]$/);
}

export function copyToClipboard(val: string) {
  try {
    const el = document.createElement("textarea");
    el.classList.add("copy-textarea");
    el.value = val;
    document.body.appendChild(el);
    el.focus();
    el.select();

    document.execCommand("copy");
    setTimeout(() => {
      document.body.removeChild(el);
      useAlertsStore().addAlert("success", "Text copied");
    }, 100);
    return true;
  } catch (error) {
    useAlertsStore().addAlert("error", "Failed to copy text");
    return false;
  }
  // window.navigator.clipboard.readText().then((text) => {
  //   if (text === val) useToast().success("MRN# copied to clipboard");
  // });
}

export const isLink = (str: string) => {
  return /^http(s)?:[/]{2}[a-zA-Z0-9-_]{2,}\.[a-zA-Z]{2,}.*/.test(str);
};
export const tryCatch = <T>(func: () => T, def: T) => {
  try {
    return func();
  } catch {
    return def;
  }
};
